import { useEffect, useState } from "react";

// Shared Google Maps JS API config.
export const GMAPS_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "";
export const GMAPS_LIBRARIES = ["places"];

export const MAP_STYLE = [
  { elementType: "geometry", stylers: [{ color: "#f4f1ec" }] },
  { elementType: "labels.text.fill", stylers: [{ color: "#6a6a6a" }] },
  { elementType: "labels.text.stroke", stylers: [{ color: "#faf7f2" }] },
  { featureType: "water", elementType: "geometry", stylers: [{ color: "#cdd9dd" }] },
  { featureType: "road", elementType: "geometry", stylers: [{ color: "#ffffff" }] },
  { featureType: "road.arterial", elementType: "geometry", stylers: [{ color: "#efe9df" }] },
  { featureType: "poi.park", elementType: "geometry", stylers: [{ color: "#dfe6d5" }] },
  { featureType: "poi", elementType: "labels.icon", stylers: [{ saturation: -60 }] },
  { featureType: "transit", stylers: [{ visibility: "simplified" }] },
];

let _promise = null;

// Loads Maps via google.maps.importLibrary (our keyed bootstrap runs first in index.html).
export function loadGoogleMaps() {
  if (typeof window === "undefined") return Promise.reject(new Error("no window"));
  if (window.google?.maps?.Map && window.google?.maps?.places?.Autocomplete) return Promise.resolve();
  if (!_promise) {
    _promise = (async () => {
      const started = Date.now();
      while (!window.google?.maps?.importLibrary) {
        if (Date.now() - started > 10000) throw new Error("gmaps bootstrap missing");
        await new Promise((r) => setTimeout(r, 60));
      }
      await window.google.maps.importLibrary("maps");
      await window.google.maps.importLibrary("marker");
      await window.google.maps.importLibrary("places");
    })();
  }
  return _promise;
}

if (typeof window !== "undefined") {
  loadGoogleMaps().catch(() => {});
}

export function useGoogleReady() {
  const [ready, setReady] = useState(() => !!(typeof window !== "undefined" && window.google?.maps?.places?.Autocomplete));
  useEffect(() => {
    let mounted = true;
    loadGoogleMaps().then(() => mounted && setReady(true)).catch(() => {});
    return () => { mounted = false; };
  }, []);
  return ready;
}
